import { render, staticRenderFns } from "./KeyBoardInput.vue?vue&type=template&id=1f645f5f&scoped=true&"
import script from "./KeyBoardInput.vue?vue&type=script&lang=js&"
export * from "./KeyBoardInput.vue?vue&type=script&lang=js&"
import style0 from "./KeyBoardInput.vue?vue&type=style&index=0&id=1f645f5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f645f5f",
  null
  
)

export default component.exports